module.exports = __webpack_public_path__ + "img/mp4.886430a7.png";